export default {
  user: null,
  licenses: [],
}
